<template>
    <v-form class="pb-10">
        <v-card-title class="">商品编辑</v-card-title>
        <v-card-text v-if="form">
            <v-row>
                <v-col cols="6">
                    <v-text-field label="名称*" name="name" placeholder="" v-model="form.name" data-vv-name="name"
                        :error-messages="errors.name" required></v-text-field>
                </v-col>
                <v-col cols="6">
                    <v-text-field label="副标题（显示是在名称下方，可以是英文名称或者简介）" v-model="form.enname"
                        :error-messages="errors.enname"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field label="特别提示（显示在卡片上，只可以显示一行，约10个汉字）" v-model="form.alert"
                        :error-messages="errors.alert"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="8" class="">
                    <country-selector @selected="onCountrySelected" :init-code="form.country"></country-selector>
                </v-col>
                <v-col cols="12" sm="4" class="d-flex justify-start align-center">
                    <!-- <flag
                        :iso="form.country"
                        style="line-height: 2rem; width: 300px; height: auto"
                    ></flag>
                    <iconify-icon
                        :icon="`circle-flags:${form.country}`"
                        width="60"
                    /> -->
                    <iconify-icon :icon="`flag:${form.country}-4x3`" width="60" />
                    <template v-if="form.country">
                        <v-icon color="warning" @click="removeCountry()">mdi-delete</v-icon>
                    </template>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" class="d-flex align-start">
                    <template v-for="(cp, i) in categoryPath">
                        <v-chip>{{ cp.name }}</v-chip> -
                    </template>
                    <template v-if="category">
                        <v-icon color="warning" @click="removeCategory">mdi-delete</v-icon>
                    </template>
                    <category-selector class="d-inline" v-model="form.category_id" :root="categoryRoot"
                        @selected="onCategorySelected" />
                </v-col>
            </v-row>

            <v-row>
                <v-col cols="4">
                    <v-text-field label="排序值" name="sequence" type="number" v-model="form.sequence"
                        :error-messages="errors.sequence" hint="默认排序值越大越靠后" persistent-hint></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-select :items="refs['STATUSLABEL']" v-model="form.status" :error-messages="errors.status"
                        label="状态" auto required item-text="text" item-value="value"></v-select>
                </v-col>
            </v-row>
            <v-card>
                <v-card-title>SKU和库存属性
                    <template v-if="form.id">
                        <v-btn @click="goTo('/item/stock/' + form.id)" color="primary" small>修改库存</v-btn>
                    </template>
                </v-card-title>
                <v-card-subtitle> 库存价格和数量保存后可修改 </v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <legend class="v-label">
                                是否限制库存数量（体现在线上购买加入购物车时）
                                <v-checkbox v-for="(l, k) in refs['STOCKABLELABEL']" :key="`stockable-${form.id}-${k}`"
                                    class="d-inline-block" v-model="form.stockable" :label="l.text"
                                    :value="l.value"></v-checkbox>
                            </legend>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field label="SKU属性名称" v-model="form.skuAtt1" :error-messages="errors.skuAtt1"
                                hint="如：规格、尺寸" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field label="取值" v-model="form.skuAttValue1" :error-messages="errors.skuAttValue1"
                                hint="逗号分隔，如：大,中,小   或 冷,热" persistent-hint></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-text-field label="SKU属性名称" v-model="form.skuAtt2" :error-messages="errors.skuAtt2"
                                hint="如：规格、尺寸" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field label="取值" v-model="form.skuAttValue2" :error-messages="errors.skuAttValue2"
                                hint="逗号分隔，如：大,中,小   或 冷,热" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field label="SKU属性名称" v-model="form.skuAtt3" :error-messages="errors.skuAtt3"
                                hint="如：规格、尺寸" persistent-hint></v-text-field>
                        </v-col>
                        <v-col cols="8">
                            <v-text-field label="取值" v-model="form.skuAttValue3" :error-messages="errors.skuAttValue3"
                                hint="逗号(,)或者空格分隔，如：大,中,小 或 冷 热" persistent-hint></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card>
                <v-card-title class="d-flex align-center">
                    图片： 上传：
                    <uploader class="d-inline" @uploaded="onImgUploaded" accept="image/*" />
                    链接：
                    <v-text-field v-model="imageUrl">
                        <template #append-outer>
                            <v-btn @click="addImgUrl">添加</v-btn>
                        </template>
                    </v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-row id="previewer" v-if="form.pics">
                        <draggable v-model="form.pics" draggable=".pic" group="people" @start="drag = true"
                            @end="drag = false">
                            <!-- 不能用 v-img ，无法显示（可能和draggable冲突 -->
                            <div v-for="(pic, idx) in form.pics" class="pic d-inline-block" :key="idx">
                                <img :alt="idx" style="max-width: 100px; max-height: 100px"
                                    :key="`itempic${form.id}-${idx}`" :src="pic"
                                    class="grey lighten-2 d-inline-block" />
                                <v-btn text color="error" @click="removeImg(idx)">
                                    <v-icon>mdi-trash-can</v-icon>
                                </v-btn>
                            </div>
                        </draggable>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card class="mt-1">
                <v-card-title>标签</v-card-title>
                <v-card-subtitle>在线订购时使用（会在相应的标签页中显示）</v-card-subtitle>
                <v-card-text>
                    <!--					<tag-editor :init-tags="form.tags" updatable deletable @changed="onTagsChanged"></tag-editor>-->
                    <v-combobox class="mr-2" style="" v-model="form.tags" :items="[]" clearable label="标签（可多选）"
                        multiple>
                        <template v-slot:selection="{ attrs, item, select, selected }">
                            <v-chip small v-bind="attrs" :input-value="selected" close @click="select"
                                @click:close="removeTag(item)">
                                <strong>{{ item }}</strong>&nbsp;
                            </v-chip>
                        </template>
                    </v-combobox>
                </v-card-text>
            </v-card>
            <v-card class="mt-1">
                <v-card-title>门店菜单标签</v-card-title>
                <v-card-subtitle>用于门店菜单支持</v-card-subtitle>
                <v-card-text>
                    <v-text-field label="" v-model="form.menuTags" :error-messages="errors.menuTags"
                        hint="如：|咖啡|手冲咖啡|饮品|咖啡因|" persistent-hint></v-text-field>
                </v-card-text>
            </v-card>
            <v-card class="mt-1">
                <v-card-title>属性</v-card-title>
                <v-card-subtitle>主要用于商品筛选、搜索</v-card-subtitle>
                <v-card-text>
                    <v-row>
                        <v-col cols="6">
                            <meta-editor :init-metas="form.metas" @changed="onMetasChanged"
                                ref="meta-editor"></meta-editor>
                            <!-- <template v-for="(m, i) in form.metas">
								{{ m.name }}:{{ m.value }}

							</template> -->
                        </v-col>
                        <v-col cols="6">
                            <v-card>
                                <v-card-title>当前分类已存在的Meta</v-card-title>
                                <v-card-text>
                                    <div v-for="(cm, i) in Object.keys(
                                        categoryMetas
                                    )" :key="i">
                                        <v-chip color="warning">{{ cm }}</v-chip>:
                                        <v-chip :key="j" v-if="categoryMetas[cm]" v-for="(mv, j) in Object.keys(
                                            categoryMetas[cm]
                                        )" @click="addMeta(cm, mv)">{{ mv }}
                                        </v-chip>
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-row class="mt-1">
                <v-col cols="12">
                    <v-subheader>描述</v-subheader>
                    <rich-editor v-model="form.description" />
                </v-col>
            </v-row>
        </v-card-text>
        <!-- zindex设置10000，避免被wangedit遮挡，wangeditor的z-index从10000开始 -->
        <v-card-actions>
            <slot name="actions" v-bind:object="form"></slot>
        </v-card-actions>
    </v-form>
</template>

<script>
import { clone, forEach } from 'lodash-es'
import CategorySelector from '../category/Selector.vue'
import SaleSelector from '../sale/Selector.vue'
import Uploader from '../common/Uploader.vue'
import draggable from 'vuedraggable'
import CountrySelector from '../common/CountrySelector.vue'
import MetaEditor from '../common/MetaEditor.vue'
import Tags from '../common/Tags.vue'
import TagEditor from '../common/TagEditor.vue'
import RichEditor from '../tools/RichEditor.vue'

export default {
    components: {
        TagEditor,
        CountrySelector,
        RichEditor,
        CategorySelector,
        SaleSelector,
        Uploader,
        draggable,
        MetaEditor,
        Tags
    },
    props: {
        value: { type: Object, default: null },
        errors: {
            type: Object,
            default: () => {
                return {}
            }
        },
        categoryRoot: { type: String, default: 'PRODUCT' },
    },
    data: () => ({
        form: null,
        category: {},
        refs: {},
        categoryMetas: [],
        categoryPath: [],
        imageUrl: null
    }),
    watch: {
        // value: {
        // 	handler(nv, ov) {
        // 		if (nv) {
        // 			console.log('watch object', nv, ov)
        // 			this.form = clone(nv)
        // 		}
        // 	},
        // 	deep: true
        // }
    },
    computed: {
        metasInGroup() {
            let re = []
            // console.log(this.form.metas)
            if (this.form.metas) {
                forEach(this.form.metas, (e) => {
                    if (!re[e.name]) re[e.name] = []
                    re[e.name].push(e.value)
                })
            }
            return re
        }
    },
    mounted() {
        if (this.value) {
            this.form = clone(this.value)
            if (this.value.category) {
                this.category = clone(this.value.category)
            } else {
                if (this.value.category_id) {
                    // console.debug('mounted', this.value)
                    this.$api.category.getById(
                        `${this.value.category_id}/detail`,
                        (r) => {
                            this.category = r
                            this.categoryPath = r.path
                        }
                    )
                } else {

                }
            }
        }
        this.$api.common.getMeta('Item', 'STATUSLABEL,STOCKABLELABEL', (r) => {
            this.refs = r
        })
        if (this.form.category_id) {
            this.loadCategoryPath(this.form.category_id)
            this.loadMetas()
        }
    },
    methods: {
        onCategorySelected(ids, objs) {
            this.$set(this.form, 'category_id', ids[0])
            this.category = objs[0]
            this.loadCategoryPath(ids[0])
            this.loadMetas()
        },
        loadCategoryPath(cid) {
            this.$api.category.getById(`${cid}/detail`, (r) => {
                this.categoryPath = r.path
            })
        },
        removeCategory() {
            this.$set(this.form, 'category_id', null)
            this.category = null
            this.categoryMetas = []
        },
        loadMetas() {
            this.$api.category.getMetas(this.form.category_id, (r) => {
                this.categoryMetas = r
            })
        },
        addMeta(name, value) {
            this.$refs['meta-editor'].addEx({ name, value })
        },
        clear() {
            this.form = {}
        },
        onImgUploaded(files) {
            if (!this.form.pics) this.form.pics = []
            this.form.pics.push(files[0])
        },
        addImgUrl() {
            this.form.pics.push(this.imageUrl)
            this.imageUrl = null
        },
        removeImg(idx) {
            this.$confirm('确定删除图片?').then((r) => {
                if (!r) return
                this.form.pics.splice(idx, 1)
            })
        },
        onSaleSelected(s) {
            console.log(s)
        },
        onCountrySelected(e) {
            this.$set(this.form, 'country', e.toLowerCase())
        },
        removeCountry() {
            this.$delete(this.form, 'country')
        },
        onTagsChanged(tags) {
            this.form.tags = tags
        },
        removeTag(item) {
            this.form.tags.splice(this.form.tags.indexOf(item), 1)
            this.$set(this.form, 'tags', [...this.form.tags])
        },
        onMetasChanged(metas) {
            this.$set(this.form, metas, metas)
        },
        onEditorChanged(html) {
            this.$set(this.form, 'description', html)
        }
    }
}
</script>
